import { render, staticRenderFns } from "./htmlGames.vue?vue&type=template&id=23f86303&"
import script from "./htmlGames.vue?vue&type=script&lang=js&"
export * from "./htmlGames.vue?vue&type=script&lang=js&"
import style0 from "./htmlGames.vue?vue&type=style&index=0&id=23f86303&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports